/**
 * Asset model
 * 
 * @class Model_Asset
 * @extends Model
 */

Model_Asset = ( function( Model ) {

	var Model_Asset = function() {
		this.construct.apply( this, arguments );
	};

	$.extend( true, Model_Asset.prototype, Model.prototype, {
		/**
		 * Construct object
		 * @constructor
		 */
		construct: function( attributes ) {
			this.data = {};
			this.init();
			this.parseData( attributes );
		},

		/**
		 * Initialize Model_Asset
		 */
		init: function() {
			/** 
			 * @property {Boolean} fetched - flag for fetching full asset detail and related assets.
			 * NOTE: it's set by Model_Asset.fetchFullDetail
			 */
			this.fetched = false;
			/** 
			 * @property {Boolean} fullDetailFetched - flag for fetching full asset detail.
			 * NOTE: it's set by Model_Asset.fetch
			 */
			this.fullDetailFetched = false;
			/** 
			 * @property {Boolean} relatedFetched - flag for fetching related assets.
			 * NOTE: it's set by Model_Asset.fetchRelated
			 */
			this.relatedFetched = false;

			/** 
			 * @property {Object} seasons - Associative array of seasons with episodes
			 * NOTE: it's filled by Model_Asset.
			 */
			this.seasons = {};
			/** 
			 * @property {Collection} relatedColl - Collection of related assets
			 * NOTE: it's filled by Model_Asset.fetchRelated
			 */
			this.relatedColl = new Collection_Assets( null, { model: Model_Asset, reqParams: { section: 'related' } } );

			/** 
			 * @property {Object} playingOptions - It keeps useful parameters for Player 
			 * NOTE: it's set by Model_Asset.setPlayingOpt(...)
			 */
			this.playingOptions = null;
		},

		parseData: function( data ) {
			this.data = {};
			$.extend( true, this.data, data );
		},


		/**
		 * [fetch description]
		 * @returns {Object} promise
		 */
		fetch: function( promise ) {
			return new Promise(function(resolve, reject) {

			if ( this.fetched ) {
				resolve();
			} else {
				Promise.all([ 
						this.fetchFullDetail(),
						this.fetchRelated() 
						]
					)
					.then( function() {
						this.fetched = true;
						resolve();
					}, this )
					.catch( function( err, response ) {
						reject( err, response );
					}, this );
			}
			
			}.bind(this));
		},

		/**
		 * To fetch full detail. Typically for fetch data about seasons.
		 * @param {Object} [promise=null] (optional). Note: if no promise is passed, then is create new promise
		 * @returns {Object} promise
		 * @returns response is passed to Model_Asset.fullDetail
		 */
		fetchFullDetail: function() {
			var scope = this;
			return new Promise(function(resolve, reject) {
				if ( this.fullDetailFetched ) {
					resolve();
				} else {
					API.fetchDetail( this.data.contentType, this.data.contentKey )
						.bind(this)
						.then( function( data ) {
							$.extend( true, scope.data, data );
							scope.fullDetailFetched = true;
							resolve();
						})
						.catch( function( err, response ) {
							App.throbberHide();
							App.notification( __( err ) );
							reject( err, response );
						});
				}
			}.bind(this))
		},

		/**
		 * To fetch related for current detail.
		 * @returns {Object} promise
		 * @returns response is passed to Model_Asset.fullDetail
		 */
		fetchRelated: function() {
			return new Promise(function(resolve, reject) {
				if ( this.relatedFetched || this.isSeries() ) {
					resolve();
				} else {
					this.relatedColl.fetchRelated( { reqParams: { section: this.getType(), id: this.getId() } } )
						.bind(this)
						.then( function() {
							var shake = function( o ) {
								for ( var j, x, i = o.length; i; j = Math.floor( Math.random() * i ), x = o[ --i ], o[ i ] = o[ j ], o[ j ] = x );
								return o;
							};
							var models = [];

							for ( var i = 0; i < this.relatedColl.length; i++ ) {
								if ( this.relatedColl.models[ i ].getID() != this.getID() ) {
									models.push( this.relatedColl.models[ i ] );
								}
							}
							models = shake( models ).slice( 0, 10 );
							this.relatedColl.models = models;
							this.relatedColl.length = models.length;

							this.relatedFetched = true;
							resolve();
						})
						.catch( function( err, response ) {
							App.throbberHide();
							App.notification( __( err ) );
							reject( err, response );
						});
				}
			}.bind(this))
		},

		/**
		 * @returns {String} Model id
		 */
		getId: function() {
			return ( this.data && this.data.contentKey ) ? this.data.contentKey : false;
		},

		/**
		 * @returns {Boolean} return value tells if full asset detail and related assets were fetched
		 */
		isFetched: function() {
			return this.fetched;
		},
		/**
		 * @returns {Boolean} return value tells if asset has fully downloaded detail
		 */
		isFullDetailFetched: function() {
			return this.fullDetailFetched;
		},
		/**
		 * @returns {Boolean} status if current asset has related assets
		 */
		isRelatedFetched: function() {
			return this.relatedFetched;
		},

		/**
		 * @returns {Boolean} status if current asset has related assets
		 */
		hasRelated: function() {
			return !!this.relatedColl.length;
		},

		/**
		 * @returns {Collection} collection of related movies
		 */
		getRelated: function() {
			return this.relatedColl;
		},

		getRelatedId: function() {
			return this.data.relId;
		},

		/**
		 * @returns {String} Movie id
		 */
		getID: function() {
			return this.getId();
		},

		/**
		 * picks the most suitable translation
		 * @param  {Object} obj with properties '*','en_US',...
		 * @return {String}     single translation
		 */
		getLocale: function( obj ) {
			return Utils.getLocale( obj );
		},



		/**
		 * @returns {String} Asset type, like "movie", "tv",...
		 */
		isSeries: function() {
			return ( this.getType() === 'tv' );
		},

		/**
		 * @returns {String} Movie title
		 */
		getTitle: function() {
			return this.getLocale( this.data.title );
		},

		/**
		 * @returns {String} Movie description
		 */
		getDescription: function() {
			var description = this.getLocale( this.data.description );

			if ( !description || !description.length || description == '-' ) {
				description = this.getSynopsis();
			}

			return description;
		},

		/**
		 * @returns {String} Movie description
		 */
		getSynopsis: function() {
			return this.getLocale( this.data.synopsis ) || '';
		},

		/**
		 * @returns {String} Asset type, like "movie", "tv",...
		 */
		getType: function() {
			return this.data.contentType || this.data.categoryName || '';
		},

		/**
		 * @returns {String} Asset type, formated
		 */
		getTypeLabel: function() {
			switch ( this.getType() ) {
				case 'movies':
					return __( 'movie' );
				case 'tv':
					return __( 'tv_series' );
			}
			return '';
		},

		/**
		 * @returns {String} Movie year
		 */
		getYear: function() {
			return this.data.productionYear || null;
		},

		/**
		 * @returns {array} 
		 */
		getGenres: function(){
			var genres = this.getSubGenres();
			genres.unshift( this.getGenre() );
			return _.uniq( genres );
		},

		/**
		 * @returns {String}
		 */
		getGenre: function() {
			return this.data.genre || '';
		},

		/**
		 * @returns {array}
		 */
		getSubGenres: function() {
			return this.data.subGenre || [];
		},

		/**
		 * @returns {String} age for parental control
		 */
		getParentalGuidance: function() {
			return this.data.parentalGuidance || '';
		},

		/**
		 * @returns {String} age for parental control
		 */
		getParentalGuidanceLabel: function() {
			// return __( this.getParentalGuidance() );
			return this.getParentalGuidance();
		},

		/**
		 * Get duration of video
		 * @returns {Number} duration of item
		 */
		getDuration: function() {
			return this.data.duration || 0;
		},

		/**
		 * Get directors
		 * @returns {Array} of strings
		 */
		getDirectors: function() {
			return this.data.directors || [];
		},

		/**
		 * Get actors
		 * @returns {Array} of strings
		 */
		getActors: function() {
			return this.data.actors || [];
		},

		/**
		 * To get URL of Main video specified by Audio
		 * @param {string} audio - audio track as ISO-639-3 code (e.g: "eng") (optional) if not then returns first MainVideoURL from List
		 * @returns {String} main video URL
		 */
		getMovieId: function( audio ) {
			return this.getId();
		},

		/**
		 * To get URL of Main video specified by Audio
		 * @param {string} audio - audio track as ISO-639-3 code (e.g: "eng") (optional) if not then returns first MainVideoURL from List
		 * @returns {String} main video URL
		 */
		getMovieUrl: function( audio ) {
			return Api.provider.getStream( this.getId() );
		},

		/**
		 * @returns {String} trailer URL
		 */
		getTrailerId: function() {
			return this.data.trailers && this.data.trailers.length ? this.data.trailers[0] : null;
		},

		/**
		 * @param {String} videoType - type of video ("main" or "trailer")
		 * @param {string} audio - audio track as ISO-639-3 code (e.g: "eng") (used only for videoType="main")
		 */
		getTrailerUrl: function() {
			return Api.provider.getStream( this.getTrailerId() );
		},

		/**
		 * @returns {String} age for parental control
		 */
		getCategoryName: function() {
			return this.data.categoryName || '';
		},

		/**
		 * @returns {String} age for parental control
		 */
		getCategoryId: function() {
			return this.data.categoryId || '';
		},



		/**
		 * Get all seasons of this series
		 * @returns {Array}
		 */
		getSeasons: function() {
			return this.data.seasons || [];
		},

		/**
		 * Get one season
		 * @param   {String} seasonID - ID of season
		 * @returns {Array}
		 */
		getSeason: function( seasonID ) {
			return _.findWhere( this.getSeasons(), { id: seasonID } ) || null;
		},

		/**
		 * Get one season
		 * @param   {String}
		 * @returns {Object}
		 */
		getSeasonByEpisodeId: function( episodeID ) {
			var seasons = this.getSeasons();
			for ( var i = seasons.length - 1; i >= 0; --i ) {
				episodes = seasons[ i ].episodes;
				for ( var j = episodes.length - 1; j >= 0; --j ) {
					if ( episodes[ j ].id == episodeID ) return seasons[ i ];
				}
			}
			return null;
		},

		/**
		 * Get one season
		 * @param   {String}
		 * @returns {String}
		 */
		getSeasonIdByEpisodeId: function( episodeID ) {
			return getSeasonByEpisodeId( episodeID ).id;
		},

		/**
		 * @param {Boolean=false} includeUnit - append unit to output number
		 * @returns {Number|String} number of seasons
		 */
		getSeasonsNumber: function( seasonID ) {
			return this.getSeason( seasonID ).seasonNumber;
		},

		/**
		 * @return {Boolean}
		 */
		hasEpisode: function() {
			return !!( this.isSeries() && this.data.seasons && this.data.seasons.length && this.data.seasons[0].episodes && this.data.seasons[0].episodes.length );
		},

		/**
		 * To get all Episodes from Season specified by given idSeason
		 * @param {String} seasonID - ID of season
		 * @returns {Array}
		 */
		getEpisodes: function( seasonID ) {
			return this.getSeason( seasonID ).episodes || [];
		},

		/**
		 * Resolve locales - used in snippet episodes list
		 * @param  {String} seasonID
		 * @return {array}
		 */
		getEpisodesForTemplate: function( seasonID ) {
			var episodes = $.extend( true, [], this.getEpisodes( seasonID ) );

			for ( var i = 0; i < episodes.length; i++) {
				episodes[i].image = '';
				episodes[i].title = this.getLocale( episodes[i].title );
				episodes[i].synopsis = this.getLocale(episodes[i].synopsis);
			}

			return episodes;
		},

		/**
		 * To get all Episodes from Season specified by given idSeason
		 * @param {String} seasonID - ID of season
		 */
		getEpisode: function( seasonID, episodeID ) {
			return _.findWhere( this.getSeason( seasonID ).episodes, { id: parseInt( episodeID ) } ) || null;
		},

		/**
		 * To get first episode.
		 * NOTE: It can be called only after called fetchFullDetail(), when Model_Asset.fullDetail is filled
		 * @returns {Object} firstEpisode - first episode (asset model) or null
		 */
		getFirstEpisode: function() {
			try {
				return this.data.seasons[0].episodes[0];
			} catch(e) {
				return null;
			}
		},

		/**
		 * To get first episode.
		 * NOTE: It can be called only after called fetchFullDetail(), when Model_Asset.fullDetail is filled
		 * @returns {String} id of first episode or null;
		 */
		getFirstEpisodeId: function() {
			try {
				return this.data.seasons[0].episodes[0].id;
			} catch(e) {
				return null;
			}
		},

		/**
		 * To get last episode.
		 * NOTE: It can be called only after called fetchFullDetail(), when Model_Asset.fullDetail is filled
		 * @returns {Object} lastEpisode - last episode (asset model) or null
		 */
		getLastEpisode: function() {
			return _.last( _.last( this.data.seasons ).episodes ) || null;
		},

		/**
		 * To get last episode.
		 * NOTE: It can be called only after called fetchFullDetail(), when Model_Asset.fullDetail is filled
		 * @returns {Object} lastEpisode - last episode (asset model) or null
		 */
		getLastEpisodeId: function() {
			return _.last( _.last( this.data.seasons ).episodes ).id || null;
		},

		/**
		 * Get duration of video
		 * @returns {Number} duration of item
		 */
		getEpisodeDuration: function( seasonID, episodeID ) {
			return this.getSeason( seasonID ).getEpisode( episodeID ).duration || 0;
		},

		/**
		 * @returns {String}
		 */
		getEpisodeTitle: function( episode ) {
			return this.getLocale( episode.title );
		},

		/**
		 * @returns {String}
		 */
		getEpisodeTitleById: function( episodeID ) {
			return this.getLocale( this.getEpisode( episodeID ).title );
		},




		/**
		 * @returns {Array} of strings - e.g. ["Indonesian", "English", "Malay", "Thai"]
		 */
		getSubtitleLanguages: function() {
			return this.data.availableSubtitles || [];
		},

		/**
		 * @returns {Boolean}
		 */
		hasSubtitles: function() {
			return !!( this.data.availableSubtitles && this.data.availableSubtitles.length );
		},

		/**
		 * @param {string} videoType - type of video ("main" or "trailer")
		 * @param {string} audio - audio track as ISO-639-3 code (e.g: "eng")
		 * @param {String} language - language of subtitles
		 * @param {Function} callback function after load subtitles
		 */
		loadSubtitles: function( videoType, audio, language, cb ) {},

		/**
		 * To get information on how to configure the player to play a video.
		 * @returns promise. if success, then response object is passed to promise. If fail, then error message is passed to promise.
		 */
		getPlaybackUrl: function( videoType ) {
			if ( videoType == 'trailer' ) {
				return this.getTrailerUrl();
			} else /*if ( videoType == 'movie' )*/ {
				return this.data.getMovieUrl();
			}
		},


		/**
		 * To verify Playback of video specified by its URL
		 * @param {String} videoUrl|videoID - url of video OR videoID
		 * @returns promise. If fail, error message is passed to promise.
		 */
		verifyPlayback: function( videoUrl ) {},

		/**
		 * To process playing requirement from some Asset before go to Player.
		 * required Sequence: login --> choose Audio --> go to Player!!
		 * @param {Object} settings - options for playing video
		 * @param {string} settings.videoType - type of video ("main" or "trailer")
		 * @param {string} settings.audio - audio track as ISO-639-3 code (e.g: "eng") (optional)
		 */
		canPlay: function( settings ) {
			if ( !settings ) {
				return false;
			}
			if ( settings.videoType === 'movie' || settings.videoType === 'episode'|| settings.videoType === 'trailer' ) {
				if ( !User.isLogged() ) {
					// TODO: user should be signed in before content playing
					return 'signin';
				} else {
					return true;
				}
			}

			return false;
		},



		/**
		 * Get the appropriate cover
		 * @param {String} type 'poster', 'hero', 'landscape', ...
		 * @returns {String} image URL, otherwise "blank"
		 */
		getImage: function( size ) {
			if ( size == 'carousel' && this.data.hasOwnProperty( 'imagePackId_carousel' ) ) {
				return App.provider.config.getImageUrl( size, this.data.imagePackId_carousel );
			}
			else if ( size == 'slider' && this.data.hasOwnProperty( 'imagePackId_slider' ) ) {  // only Home scene - hardcoded red labels
				return App.provider.config.getImageUrl( 'small', this.data.imagePackId_slider );
			}
			else if ( size == 'detail' && this.data.hasOwnProperty( 'imagePackId' ) ) {
				return App.provider.config.getImageUrl( 'medium', this.data.imagePackId );
			}
			else if ( size == 'search' && this.data.hasOwnProperty( 'imagePackId' ) ) {
				return App.provider.config.getImageUrl( 'tiny', this.data.imagePackId );
			}
			else if ( size == 'related' && this.data.hasOwnProperty( 'imagePackId' ) ) {
				return App.provider.config.getImageUrl( 'medium', this.data.imagePackId );
			}
			else if ( _.contains( [ 'grid', 'slider', 'related' ], size ) && this.data.hasOwnProperty( 'imagePackId' ) ) {
				return App.provider.config.getImageUrl( 'small', this.data.imagePackId );
			}
			else if ( _.contains( [ 'grid', 'slider', 'related', 'search' ], size ) && this.data.hasOwnProperty( 'imageUrl' ) ) {
				return 'https:' + this.data.imageUrl;  // imageUrl is for 200×300
			}
			else {
				return this.getEmptyCover( size || 'related' );
			}
		},

		getCarouselImage: function() {
			return this.getImage( 'carousel' );
		},
		getSliderImage: function() {
			return this.getImage( 'slider' );
		},
		getDetailImage: function() {
			return this.getImage( 'detail' );
		},
		getGridImage: function() {
			return this.getImage( 'grid' );
		},
		getRelatedImage: function() {
			var requiredX = 216;
			var requiredY = 324;

			var originalUrl = this.getImage( 'related' );
			var resizeParamString = 'resize[]=';
			var resizeParamStringLength = resizeParamString.length;
			var firstMatchPosition = originalUrl.indexOf(resizeParamString);
			var lastMatchPosition = originalUrl.lastIndexOf(resizeParamString);
			var sliced = originalUrl.slice(firstMatchPosition + resizeParamStringLength);
			var x = parseInt(sliced, 10);
			var y = parseInt(originalUrl.slice(lastMatchPosition + resizeParamStringLength), 10);

			sliced = sliced.replace(x.toString(), requiredX.toString());
			sliced = sliced.replace(y.toString(), requiredY.toString());

			return originalUrl.slice(0, firstMatchPosition) + resizeParamString + sliced;
		},
		getSearchImage: function() {
			return this.getImage( 'search' );
		},

		getEmptyCover: function( size ) {
			return "./img/empty-" + size + ".png";
		}

	} );

	return Model_Asset;

} )( Model );



//////////////////
// WEBPACK FOOTER
// ./js/model/asset.js
// module id = 44
// module chunks = 0